import { useEffect, useState } from 'react'
import settingsService from '@api/v1/settingsService'
import { getTenant } from '@config/tenant'

/**
 * CC-49981 — the firm name for report print/PDF/export mastheads.
 *
 * The masthead used to print `getTenant()`, i.e. the subdomain the user happens
 * to be on ("vladdemo"), which is frequently not the firm's real name. Firms are
 * advised to maintain their name in system settings, and the legacy app agrees:
 * `AccountingController.ReconciliationReport` stamps its report header from
 * `GetServerSetting("Invoice_CompanyName")` (Views/Accounting/ReconciliationReport.cshtml),
 * and `Constants.INVOICE_NAME` names the same key.
 *
 * Read through the EXISTING `/settings/server` endpoint (cb-api is
 * backend-owned — no new or modified route). Falls back to the tenant name when
 * the setting is empty or unreadable, so the masthead is never blank.
 *
 * Call once per page and pass the value down; each call is its own fetch.
 */
export const FIRM_NAME_SETTING = 'Invoice_CompanyName'

const useFirmName = () => {
  const [firmName, setFirmName] = useState('')

  useEffect(() => {
    let cancelled = false
    settingsService
      .getServerSettings([FIRM_NAME_SETTING])
      .then((settings) => {
        if (!cancelled) setFirmName(String(settings?.[FIRM_NAME_SETTING] ?? '').trim())
      })
      // Fail soft — the tenant fallback below still yields a usable masthead.
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  return firmName || getTenant() || ''
}

export default useFirmName
